class Entry {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    if (this.getUrlParam('work')) {
      document.querySelector(`[value="${this.getUrlParam('work')}"]`).checked = true;
    }

    setTimeout(() => {
      $('.js-occupation-radio').eq(0).prop('checked', true);
    }, 300);
    val_change($('.js-occupation-radio').eq(0));

    function val_change(el) {
      $(`[name="${el.attr('data-name')}"]`).val(el.attr('value'));
    }

    $('.js-occupation-radio').change(function() {
      val_change($(this));
    })

    $('.js-occupation-trigger input[type="radio"]').change(function() {
      let radio = $(this);
      let trueEl = true;
      $('.js-occupation-radio').each(function(index, el) {
        if($(el).attr('data-cat') == radio.val()) {
          $(el).parent().parent().css({'display':'block'});
          if(trueEl == true) {
            $(el).prop('checked', true);
            val_change($(el));
            trueEl = false;
          }
        } else {
          $(el).parent().parent().css({'display':'none'});
        }
      })
    })
  }
  
  getUrlParam(param) {
    // クエリストリングを取得し、パラメータを分解
    var pageUrl = window.location.search.substring(1);
    var urlVariables = pageUrl.split('&');
    
    // 各パラメータをループして目的のパラメータを探す
    for (var i = 0; i < urlVariables.length; i++) {
        var parameterName = urlVariables[i].split('=');
        
        // 指定されたパラメータが見つかった場合、その値を返す
        if (parameterName[0] === param) {
            return parameterName[1] === undefined ? true : decodeURIComponent(parameterName[1]);
        }
    }
    
    // 指定されたパラメータが見つからない場合、nullを返す
    return null;
  }
}